export function withTimeHHmm(date: Date, time: string): Date {
  const result = new Date(date);
  if (time) {
    const [hours, minutes] = time.split(':');
    result.setHours(Number(hours), Number(minutes));
  }
  return result;
}
